module.exports = __webpack_public_path__ + "media/images/rank_04-86450719085b1aa49a24f9b6f908d0b4.png";